import Link from "next/link"

import styles from './breadcrumb.module.scss'
import { isProd } from '@/lib/utilities/system'

export type BreadcrumbItemProps = {
  index?: number,
  link: string,
  label: string,
}

export const BreadcrumbItem = ({
  index,
  link,
  label,
}: BreadcrumbItemProps) => {
  if (link.length === 0) {
    return (
      <p className={`${styles.crumb} ${styles.text} ${!isProd() ? `breadcrumb_${index}` : ''}`}>
        {label}
      </p>
    )
  }

  return (
    <Link
      href={link}>
      <a className={`${styles.crumb} ${!isProd() ? `breadcrumb_${index}` : ''}`}>
        {label}
      </a>
    </Link>
  )
}